import React, { useState, useEffect } from "react";
import {
    useDeleteEditExtensionDataMutation,
    useExtensionDataQuery,
} from "../../../../Services/Telephony/Telephony";
import LoadingSpinner from "../../../LoadingSpinner";
import { Box, IconButton, Modal, Tooltip, Typography } from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";
import EditExtensionModal from "./EditExtensionModal";
import DeleteModal from "./DeleteModal";
import DeleteContactModal from "../../../contact/contact/DeleteContactModal";
import AddExtension from "./AddExtension";
import { Loader } from "react-bootstrap-typeahead";
import * as XLSX from "xlsx";
import EmptyRows from "../../../reusableComponent/EmptyRows";


const ExtensionCreation = () => {
    const [extensionData, setExtensionData] = useState<any>([]);
    const [editExtensionModalOpen, setEditExtensionModalOpen] =
        useState<boolean>(false);
    const [extensionId, setExtensionId] = useState("");
    const [deleteExtensionFieldModalOpen, setDeleteExtensionFieldModalOpen] =
        useState(false);
    const [openAddExtensionModal, setOpenAddExtensionModal] = useState(false);
    const [extensionLoader, setExtensionLoader] = useState(false);
    const [agentMappingDownloadButtonClicked,setAgentMappingDownloadButtonClicked] = useState<boolean>(false)
    const [downloadLoader, setDownloadLoader] = useState(false)



    const extension = [
        { label: "Sr.No", key: "sno" },
        { label: "Extension", key: "extension" },
    ];

    const [deleteExtensionTrigger] = useDeleteEditExtensionDataMutation();

    const {
        data: telephonyExtensionData,
        isLoading,
        status,
        refetch,
    } = useExtensionDataQuery({});

    useEffect(() => {
        if (status === "pending") {
            setExtensionLoader(true);
        } else {
            setExtensionLoader(false);
        }
    }, [status]);

    useEffect(() => {
        if (agentMappingDownloadButtonClicked) {

            downloadAgentMappingData()
        }

    }, [agentMappingDownloadButtonClicked])

    console.log(downloadLoader, "sdcdscsccc")

    useEffect(() => {
        if (telephonyExtensionData) {
            setExtensionData(telephonyExtensionData);
        }
    }, [telephonyExtensionData]);

    const EditModal = (id: any) => {
        setExtensionId(id);
        setEditExtensionModalOpen(true);
    };

    const closeModal = () => {
        setEditExtensionModalOpen(false);
        setDeleteExtensionFieldModalOpen(false);
        setOpenAddExtensionModal(false);
    };

    const isDeleteModal = (id: any) => {
        setExtensionId(id);
        setDeleteExtensionFieldModalOpen(true);
    };

    const addExtensionHandler = (e) => {
        e.preventDefault();
        setOpenAddExtensionModal(true);
    };

    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "40%",
        overflow: "scroll",
        bgcolor: "background.paper",
        border: "1px solid transparent",
        boxShadow: 2,
        borderRadius: "5px",
        p: 4,
        paddingBottom: "0",
    };


    const downloadAgentMappingData = async () => {
        setAgentMappingDownloadButtonClicked(true)
        // setDownloadLoader(true)
        if ( extensionData&& extensionData.length > 0) {
          const csvData = extensionData?.map((user, index) => ({
            "Sr.No": index+1,
            Extension: user?.extension,
          }));
    
          const worksheet = XLSX.utils.json_to_sheet(csvData);
    
          const csvOutput = XLSX.utils.sheet_to_csv(worksheet);
    
          const blob = new Blob([csvOutput], {
            type: "text/csv;charset=utf-8;",
          });
          const link = document.createElement("a");
          const url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", "Extension_Data.csv");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        //   setAgentLoader(false)
        setAgentMappingDownloadButtonClicked(false)

        // setDownloadLoader(false);

        // setDownloadAgentMappingTableData([]);
        } else {
            // setDownloadLoader(false)
        setAgentMappingDownloadButtonClicked(false)

        //   setAccountDownloadLoading(false);
        }
      };
    return (
        <div style={{marginLeft:"3%", marginRight: "3%"}}>
            <div style={{display: "flex", gap: "10px", width: "100%", marginBottom: "20px"}}>
                <div style={{ width: "85%"}}>
                    <span className="input-group-text" id="basic-addon1">
                        Extension creation
                    </span>
                </div>
                <div style={{flex: "1", display: "flex", gap: "10px", justifyContent: "end"}}>
                    <div className="card-toolbar d-flex gap-2">
                        <button
                            className="input-group-text form-control btn-sm fw-bold d-flex align-items-center min-w-150px"
                            style={{justifyContent: "center", fontSize: "15px"}}
                            onClick={addExtensionHandler}
                        >
                            <i className="bi bi-plus-lg text-dark me-2"></i>
                            <span>Add extension</span>
                        </button>
                    </div>
                    <Tooltip title="Download extension Data">
                    <IconButton
                      onClick={() => {
                        setAgentMappingDownloadButtonClicked(true);

                        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                        downloadAgentMappingData;
                      }}
                    >
                      {downloadLoader ? (
                        <Loader />
                      ) : (
                        <i
                          className="bi bi bi-download"
                          style={{
                            fontSize: "25px",
                            color: "black",
                          }}
                        ></i>
                      )}
                    </IconButton>
                  </Tooltip>

                    {/* <span style={{display:"flex", justifyContent: "end", background:"#f5f8fa"}}>Add</span> */}
                </div>
            </div>

            <div className="row">
                <div className="col">
                    <div
                        className="card  my-1 p-4"
                        style={{ backgroundColor: "#E4E4E47F" }}
                    >
                        <div className="row align-items-center">
                            {extension?.map((card, index) => (
                                <div
                                    className="col"
                                    style={{
                                        textAlign:
                                            card.label === "Extension"
                                                ? "center"
                                                : "start",
                                    }}
                                    key={index}
                                >
                                    <label htmlFor="">
                                        <strong
                                            style={{
                                                display: "flex",
                                                gap: "2px",
                                            }}
                                        >
                                            {card?.label}
                                            {/* {card.label !== "Branch user" &&
                      card.label !== "Role" &&
                      card.label !== "Last updated date" && (
                        <SortingTableUsers
                          index={
                            card.label === "User"
                              ? "username"
                              : card.label === "Created by"
                              ? "created"
                              : card.label === "User id"
                              ? "id"
                              : card.label
                          }
                          setLiftingColumn={setLiftingColumn}
                        />
                      )} */}
                                        </strong>
                                    </label>
                                </div>
                            ))}
                            <div className="col text-end">
                                <label
                                    htmlFor=""
                                    style={{ paddingRight: "25px" }}
                                >
                                    <strong>Action</strong>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row" style={{ height: "65vh", overflow: "auto" }}>
                {!extensionData?.length ? <EmptyRows value={''}/> :  
                <div className="col" style={{ paddingRight: "0px" }}>
                    {isLoading || extensionLoader ? (
                        <LoadingSpinner />
                    ) : (
                        <>
                            {extensionData?.length ? (
                                <>
                                    {extensionData?.map(
                                        (user: any, index: any) => (
                                            <div
                                                className="card mt-2 my-1 p-4"
                                                key={index}
                                            >
                                                <div className="row align-items-start">
                                                    <div className="col text-start">
                                                        <label
                                                            htmlFor=""
                                                            style={{
                                                                paddingLeft:
                                                                    "10px",
                                                            }}
                                                        >
                                                            {index + 1}
                                                        </label>
                                                    </div>

                                                    <div
                                                        className="col text-center"
                                                        data-toggle="tooltip"
                                                        data-placement="top"
                                                        title={
                                                            user?.recording_path
                                                        }
                                                    >
                                                        <label htmlFor="">
                                                            {user?.extension}
                                                        </label>
                                                    </div>

                                                    <div
                                                        className="col text-center d-flex"
                                                        style={{
                                                            gap: "10px",
                                                            justifyContent:
                                                                "end",
                                                            paddingRight:
                                                                "25px",
                                                        }}
                                                    >
                                                        <button
                                                            className="text-hover-primary border-0 bg-white me-2"
                                                            title="Edit"
                                                            onClick={() =>
                                                                EditModal(
                                                                    user.id
                                                                )
                                                            }
                                                            // onClick={() => isEditModal(user)}
                                                        >
                                                            <i className="bi bi-pencil text-dark fs-4"></i>
                                                        </button>
                                                        <button
                                                            className="text-hover-danger border-0 bg-white me-2"
                                                            title="Delete"
                                                            onClick={() =>
                                                                isDeleteModal(
                                                                    user
                                                                )
                                                            }
                                                        >
                                                            <i className="bi bi-trash text-dark fs-4"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    )}
                                </>
                            ) : (
                                ""
                                // <EmptyRows value={""} />
                            )}
                        </>
                    )}
                </div>
}
            </div>

            <Modal
                open={editExtensionModalOpen}
                onClose={closeModal}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
            >
                <Box sx={{ ...style, position: "absolute" }}>
                    <IconButton
                        aria-label="close"
                        onClick={closeModal}
                        sx={{
                            position: "fixed",
                            top: 16,
                            right: 16,
                            zIndex: 1301,
                            background: "white",
                        }} // Ensure it's above the modal content
                    >
                        <GridCloseIcon />
                    </IconButton>
                    <Typography
                        id="modal-title"
                        variant="h6"
                        component="h2"
                        sx={{ mb: 2 }}
                        style={{
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        Edit extension
                    </Typography>

                    <Box>
                        <EditExtensionModal
                            closeModal={closeModal}
                            // refetchingData={refetchTelephonyServerData}
                            editExtensionId={extensionId}
                            refetch={refetch}
                        />
                    </Box>
                </Box>
            </Modal>

            <Modal
                open={openAddExtensionModal}
                onClose={closeModal}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
            >
                <Box sx={{ ...style, position: "absolute" }}>
                    <IconButton
                        aria-label="close"
                        onClick={closeModal}
                        sx={{
                            position: "fixed",
                            top: 16,
                            right: 16,
                            zIndex: 1301,
                            background: "white",
                        }} // Ensure it's above the modal content
                    >
                        <GridCloseIcon />
                    </IconButton>
                    <Typography
                        id="modal-title"
                        variant="h6"
                        component="h2"
                        sx={{ mb: 2 }}
                        style={{
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        Add extension
                    </Typography>

                    <Box>
                        <AddExtension
                            closeModal={closeModal}
                            refetch={refetch}
                        />
                    </Box>
                </Box>
            </Modal>

            <Modal
                open={deleteExtensionFieldModalOpen}
                onClose={closeModal}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
            >
                <Box sx={{ ...style, position: "absolute" }}>
                    <IconButton
                        aria-label="close"
                        onClick={closeModal}
                        sx={{
                            position: "fixed",
                            top: 16,
                            right: 16,
                            zIndex: 1301,
                            background: "white",
                        }} // Ensure it's above the modal content
                    >
                        {/* <GridCloseIcon /> */}
                    </IconButton>
                    {/* <Typography
                                        id="modal-title"
                                        variant="h6"
                                        component="h2"
                                        sx={{ mb: 2 }}
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                        }}
                                    >
                                        Edit Extension

                                    </Typography> */}

                    <Box>
                        <DeleteContactModal
                            closeModal={closeModal}
                            // refetchingData={refetchTelephonyServerData}
                            setFieldsData={setExtensionData}
                            fieldsData={extensionData}
                            storingFieldData={extensionId}
                            refetch={refetch}
                            // storingFieldData={extensionId}
                            trigger={deleteExtensionTrigger}
                        />
                    </Box>
                </Box>
            </Modal>
        </div>
    );
};

export default ExtensionCreation;
